import { render, staticRenderFns } from "./BeCuponDetails.vue?vue&type=template&id=86e030a8&"
import script from "./BeCuponDetails.vue?vue&type=script&lang=js&"
export * from "./BeCuponDetails.vue?vue&type=script&lang=js&"
import style0 from "./BeCuponDetails.vue?vue&type=style&index=0&id=86e030a8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports